import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { device } from '../../../lib/theme';

const BoxContainer = styled.div`
  box-shadow: 0px 3px 20px #00000029;
  height: 450px;
  padding-left: 24px;
  padding-right: 24px;
  position: relative;
  width: 100%;
  max-width: 400px;
`;

const BoxContainerImg = styled.img`
  left: calc(50% - 60px);
  position: absolute;
  top: -60px;
  width: 120px;

  @media ${device.laptop} {
    left: calc(50% - 75px);
    top: -75px;
    width: 150px;
  }
`;

const defaultLocations = [
  {
    name: 'AAA Matthews',
    address: '9404 E Independence Blvd, <br />Matthews, NC 28105',
    url: 'https://locator.carolinas.aaa.com/nc/matthews/aaa-matthews',
  },
  {
    name: 'AAA WT Harris',
    address: '1740 Flat River Dr, <br />Charlotte, NC 28262',
    url: 'https://locator.carolinas.aaa.com/nc/charlotte/aaa-wt-harris-blvd',
  },
];

const displayLocations = (locations?: Array<any>) => {
  return (
    <>
      {locations?.map((location) => (
        <div key={location.name} style={{ marginBottom: 24 }}>
          <p style={{ marginBottom: 0 }}>
            <strong>{location.name}</strong>
          </p>
          <p
            style={{ marginBottom: 8, lineHeight: '1.2em' }}
            dangerouslySetInnerHTML={{ __html: location.address }}
          />

          <Button
            size="small"
            type="text"
            href={location.url}
            style={{ color: '#cd2127', padding: 0, fontWeight: 900 }}
          >
            See location details or reserve online
          </Button>
        </div>
      ))}
    </>
  );
};

const CarCareLocationBox: React.FC<{
  locations?: Array<any>;
}> = ({ locations = defaultLocations }) => (
  <BoxContainer>
    <BoxContainerImg
      src="https://aaacdndev.blob.core.windows.net/wordpress/2021/02/Map_Image.png"
      alt="Map Icon Centered"
    />
    <h2
      style={{
        fontFamily: `'CG-bold', sans-serif`,
        paddingTop: '100px',
      }}
    >
      Now Visit Us At:
    </h2>

    {displayLocations(locations)}
  </BoxContainer>
);

export default CarCareLocationBox;
